import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    ElementRef,
    HostListener,
} from '@angular/core';

import { ProductService } from '../../../services/product.service';
import { FilterGroup } from '../../../models/filter-group.model';
import { AppSettings } from '../../../app.settings';
import { HEADER_HEIGHT, LocalStorageService } from '../../../services/local-storage.service';
import {isEmptyArray, updateItemInArray} from '../../../shared/utils';
import {MobileCheckServiceService} from '../../../services/mobile-check-service.service';

const PADDING = 15;
const SCROLL_WIDTH = 16
const FOOTER_HEIGHT = 104;
const FILTER_PADDING = 15;
const MAX_MOBILE_WIDTH = 375;

const ROW_FILTERS_IDS =  [1, 2, 3, 4];
@Component({
    selector: 'products-row-filter',
    templateUrl: './row-filter.component.html',
    styleUrls: ['./row-filter.component.scss'],
    encapsulation: ViewEncapsulation.None
})

// ! NOTE - the "1" is tmp, should be the product group ID
// "1" is the default for eComm

export class RowFilterComponent implements OnInit {

    @Output() update = new EventEmitter();

    mobileOpened = false;

    fixedPosition = false; // in case fixHeader = true, the component should be  fixed on top
    private offsetTop = 0;
    private maxHeight = window.innerHeight;
    private filterMaxHeight = 200;
    private componentWidth = 200;
    private componentLeftOffset = PADDING;
    private componentTopOffset = 0;
    private parentElement: HTMLElement;
    filterItemMaxHeight = 160;

    _filters: FilterGroup[] = [];
    @Input() public set filters(val: FilterGroup[]) {
        if (!isEmptyArray(val)) {
            this._filters = val.map( v => new FilterGroup(v));
        } else {
            this._filters = [];
        }
    }

    constructor(protected productService: ProductService,
                private elementRef: ElementRef,
                private appSettings: AppSettings,
                private localService: LocalStorageService,
                private mobileCheck: MobileCheckServiceService) {
    }

    ngOnInit() {
        this.parentElement = this.elementRef.nativeElement.parentElement;
    }

    updateFilters(filterGroup: FilterGroup) {
        if (!filterGroup) {
            return;
        }
        // close all filters
        this._filters.forEach( f => {
            if (f.expanded) {
                f.expanded = false;
            }
        });

        this._filters = updateItemInArray<FilterGroup>(this._filters, filterGroup);
        this.update.emit(this._filters);
        this.closeMobileFilter();
    }


    toggleDropdown(filterGroup: FilterGroup) {
        // collapse all other filters
        if (filterGroup?.expanded) {
            this._filters.forEach( f => {
                if (f.id !== filterGroup.id) {
                    f.expanded = false;
                }
            });
        }

        this._filters = updateItemInArray<FilterGroup>(this._filters, filterGroup);
    }

    onFilterChanged(filterGroup: FilterGroup) {
        if (filterGroup.changed) {
            this._filters =  this._filters.map( f => {
               f.changed = true;
               return f;
            });
        }
    }






    @HostListener('document:mousedown', ['$event'])
    onWindowClick(event) {
        if (this.mobileOpened && !this.elementRef.nativeElement.contains(event.target)) {
            // clicked outside => close dropdown list
            this.toggleFiltersModal();
        }
    }

    get styles() {

        const style = {
            'maxHeight.px': Math.floor(this.maxHeight),
            'width.px': Math.floor(this.componentWidth),
            'overflow-y': 'hidden'
        };
        if (this.fixedPosition && !this.mobile) {
            style['left.px'] = this.componentLeftOffset;
            style['top.px'] = this.componentTopOffset;
        }

        return style;
    }






    isVisible(filterGroup: FilterGroup): boolean {
        return filterGroup.visible;
    }


    get filtersCount(): number {
        return this._filters ? this._filters.filter( f =>  f.visible === true).length : 0;
    }


    clearAll() {
        this._filters.forEach( f => {
            f.clearSelection();
            f.expanded = false;
        });

        this.update.emit(this._filters);
        this.closeMobileFilter();
        return false;
    }

    private getElementRect(): any {

        if (this.elementRef.nativeElement.children.length > 0) {
            if (this.elementRef.nativeElement.children[0].children.length > 0) {
                return this.elementRef.nativeElement.children[0].children[0].getBoundingClientRect();
            }
        }

        return {
            top: 0,
            height: 0
        }

    }
    get visible(): boolean {
        return !isEmptyArray(this._filters);
    }


    get hasSelectedFilters(): boolean {
        if (isEmptyArray(this._filters)) {
            return false;
        }

        return this._filters.reduce( (total, i) => (total += i.selectedFilters.length), 0) > 0;
    }


    toggleFiltersModal() {
        this.mobileOpened = !this.mobileOpened;
        return false;
    }

    closeMobileFilter() {
        if (this.mobileOpened) {
            this.toggleFiltersModal();
        }
    }

    get mobile(): boolean {
        return this.mobileCheck.mobile;
    }


    // for row only Brand , Program , Category and Product Type  are needed
    get filtersInRow(): FilterGroup[] {
        if (isEmptyArray(this._filters)) {
            return this._filters;
        }

        return this._filters.filter( f => ROW_FILTERS_IDS.includes(f.id));
    }

    get sortedFiltersGroup(): FilterGroup[] {
        const filters  =  this.filtersInRow;

        if (isEmptyArray(filters)) {
            return filters;
        }

        return  filters.sort( (a, b) => {
            return a.ord - b.ord;
        })
    }
}
